import Signin from './pages/Auth/Signin';
import { useSelector } from 'react-redux';
import { RootState } from './store/store';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ADMINDASHBOARD, CALLDASHBOARD, PROFILE, SIGNIN } from './common/constants';
import Header from './layout/Header';
import { ToastContainer } from 'react-toastify';
import AdminDashboard from './pages/Admin Dashboard/AdminDashboard';
import AuthVerify from './common/AuthVerify';
import CallDashboard from './pages/Call Dashboard/CallDashboard';
import Sidebar from './layout/Sidebar';
import UserLayout from './layout/UserLayout';

function App() {
  const { admin } = useSelector((state: RootState) => state.auth)
  const token = admin?.token;
  return (
    <div className="App">
      <ToastContainer />
      <BrowserRouter>
        {
          !token ?
            <Routes>
              <Route path='*' caseSensitive={false} element={<Navigate to={SIGNIN} />} />
              <Route path={SIGNIN} caseSensitive={false} element={<Signin />} />
            </Routes>
            :
            <>
              {/* <Header /> */}

              {/* <Sidebar /> */}
              <Routes>
                <Route element={<UserLayout />}>
                  <Route path="*" caseSensitive={false} element={<Navigate to={(`${CALLDASHBOARD}`)} />} />
                  <Route path={ADMINDASHBOARD} caseSensitive={false} element={<AdminDashboard />} />
                  <Route path={CALLDASHBOARD} caseSensitive={false} element={<CallDashboard />} />
                </Route>
              </Routes>

              <AuthVerify />
            </>
        }
      </BrowserRouter>
    </div>
  );
}

export default App;